<template>
    <modal id="checking-modal"
        size="large"
        v-model="showModal"
        :title="generateModalTitle('checking')"
        @submit="submitData" :loading="loading"
        :preloader="preloader">

        <form
            ref="form"
            :data-url="selectedUrl ? selectedUrl : `${TENANT_BASE_URL}app/hotel/checking`"
            @submit.prevent="submitData"
        >
            <div class="row">
                <div class="col-md-6">
                    <app-form-group
                        type="date"
                        :label="$t('date')"
                        v-model="formData.date"
                        :placeholder="formData.date ? $placeholder('date') : this.$t('not_added_yet')"
                        :error-message="$errorMessage(errors, 'date')"
                    />
                </div>
                <div v-if="!room_id" class="col-md-6">
                    <app-form-group-selectable
                        type="search-select"
                        :label="$t('room')"
                        list-value-field="name"
                        v-model="formData.room_id"
                        :chooseLabel="$t('room')"
                        :error-message="$errorMessage(errors, 'room_id')"
                        :fetch-url="`${TENANT_BASE_URL}selectable/hotel/room?hotel_id=${hotel_id}`"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        type="time"
                        v-model="formData.start_time"
                        :label="$t('start_time')"
                        :required="true"
                        :error-message="$errorMessage(errors, 'start_time')"
                        :placeholder="$t('enter_start_time')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        type="time"
                        v-model="formData.end_time"
                        :label="$t('end_time')"
                        :required="true"
                        :error-message="$errorMessage(errors, 'end_time')"
                        :placeholder="$t('enter_end_time')"
                    />
                </div>
                <div class="col-md-12">
                    <app-form-group-selectable
                        type="multi-select"
                        :label="$t('checker')"
                        list-value-field="employee_name"
                        v-model="formData.checker"
                        :chooseLabel="$t('checker')"
                        :error-message="$errorMessage(errors, 'checker')"
                        :fetch-url="`${TENANT_BASE_URL}selectable/hotel/member?field_id=employee_id&hotel_id=${hotel_id}`"
                    />
                </div>
                <div class="col-md-12">
                    <app-form-group-selectable
                        type="multi-select"
                        :label="$t('tags')"
                        list-value-field="title"
                        v-model="formData.tags"
                        :chooseLabel="$t('tags')"
                        :error-message="$errorMessage(errors, 'tags')"
                        :fetch-url="`${TENANT_BASE_URL}selectable/hotel/shortcoming?hotels=${hotel_id}&per_page=0`"
                    />
                </div>
                <div class="col-md-12">
                    <app-form-group
                        type="switch"
                        v-model="formData.shortcoming"
                        :label="$t('shortcoming')"
                        :required="false"
                        :error-message="$errorMessage(errors, 'shortcoming')"
                    />
                </div>
                <div class="col-md-12">
                    <app-form-group
                        :label="$t('attachments')"
                        type="file"
                        v-model="images"
                        :multiple="true"
                        :placeholder="$placeholder('attachments', '')"
                        :file-label="$placeholder('attachments', '')"
                        :error-message="$errorMessage(errors, 'images.0')"
                    />
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../../common/Mixin/Global/ModalMixin";
import {TENANT_BASE_URL} from "../../../../../../common/Config/UrlHelper";
import {formDataAssigner} from "../../../../../../common/Helper/Support/FormHelper";
import {formatDateForServer, formatTimeForServer, today} from "../../../../../../common/Helper/Support/DateTimeHelper";

export default {
    name  : "CheckingCreateEditModal",
    mixins: [FormHelperMixins, ModalMixin],
    props : {
        hotel_id: null,
        room_id : null,
    },
    data() {
        return {
            TENANT_BASE_URL,
            images         : [],
            formData       : {
                hotel_id: this.hotel_id ? this.hotel_id : null,
                room_id : this.room_id ? this.room_id : null,
                date    : formatDateForServer(today()),
                checker : [],
            },
        }
    },
    methods: {
        submitData() {
            this.loading = true
            let url      = this.$refs.form.dataset["url"];
            let formData = formDataAssigner(new FormData, this.formData);

            formData.set('date', formatDateForServer(this.formData.date))
            formData.set('checker', JSON.stringify(this.formData.checker))
            formData.set('tags', JSON.stringify(this.formData.tags))
            formData.set('shortcoming', this.formData.shortcoming === 'false' ? 0 : 1)

            this.images.forEach(file => formData.append('images[]', file))

            if (this.formData.start_time) {
                formData.set('start_time', formatTimeForServer(this.formData.start_time))
            }
            if (this.formData.end_time) {
                formData.set('end_time', formatTimeForServer(this.formData.end_time))
            }

            if (this.selectedUrl) {
                // for file update need to send by post.
                formData.append('_method', 'PATCH');
            }

            this.submitFromFixin('post', url, formData);
        },
        afterSuccess({data}) {
            this.formData = {
                hotel_id: this.hotel_id ? this.hotel_id : null,
                date    : formatDateForServer(today()),
            };
            $('#checking-modal').modal('hide');
            this.$emit('input', false);
            this.toastAndReload(data.message, 'checking-table');
        },
        afterSuccessFromGetEditData(response) {
            this.preloader = false;
            this.formData  = response.data;
        },
    },
}
</script>

